export default "__VITE_ASSET__b2b875d6__"